{
  "WALLBOARD": {
    "LOADING": "Notiek tālruņa rindu ielāde...",
    "NO_QUEUES": "Nav atrasta neviena tālruņa rinda.",
    "NO_AGENTS": "Šajā rindā nav tiešsaistes aģentu.",
    "UNKNOWN_CALLER": "Nezināms Zvanītājs",
    "STATUS": "Statuss",
    "TIME": "Laiks",
    "AGENT": "Aģents",
    "EXTENSION": "Iekšējais Numurs",
    "READY": "Gatavie Aģenti",
    "ON_CALL": "Aģenti Zvanā",
    "PAUSED": "Aģenti Pauzē",
    "WAITING": "Gaidošie Zvani",
    "MISSED_CALLS": "Neatbildētie Zvani",
    "HANDLED_CALLS": "Apstrādātie Ienākošie Zvani",
    "OUTBOUND_CALLS": "Apstrādātie Izejošie Zvani",
    "AVAILABILITY": "Pieejamība",
    "AVAILABILITY_TOOLTIP": "Ienākošo zvanu procentuālā daļa, uz kuriem atbildējuši aģenti (zvani, kas tika pacelti)",
    "AGENTS_COUNT": "({onCall} sarunā / {total} kopā)",
    "NO_AVAILABLE": "(neviens nav tiešsaistē)",
    "WAITING_CALLERS_COUNT": "{count} gaida",
    "CALLER": "Zvanītājs",
    "NUMBER": "Numurs",
    "WAIT_TIME": "Gaidīšanas Laiks",
    "ACTION": "Darbība",
    "PICKUP_CALL": "Pacelt",
    "PICKUP_SUCCESS": "Zvana pacelšana veiksmīgi pieprasīta.",
    "PICKUP_ERROR": "Neizdevās pacelt zvanu. Lūdzu, mēģiniet vēlreiz.",
    "PICKUP_DISABLED_TOOLTIP": "Jūs nevarat pacelt zvanu, kamēr esat sarunā vai bezsaistē.",
    "CHAT_STATUS": {
      "NO_ACCESS": "Nav piekļuves"
    },
    "PHONE_STATUS": {
      "NO_ACCESS": "Nav piekļuves"
    }
  }
}
